/**
 * @typedef {import('./lib/index.js').Options} Options
 * @typedef {import('./lib/index.js').Matter} Matter
 * @typedef {import('./lib/index.js').Info} Info
 */

export {frontmatterFromMarkdown, frontmatterToMarkdown} from './lib/index.js'
